export default "__VITE_ASSET__BCV6oBhj__"